(function () {
  'use strict'

  /**
     * @ngdoc module
     * @name ThismomentGlowModal
     * @module thismoment.glow.component.glow-modal.glow-modal
     *
     * @description
     * The glow modal. Any glow module that invokes a modal uses this to provide a unified form/busy/error/success state
     */

  const MODULE_NAME = 'thismoment.glow.component.glow-modal.core'
  const templateUrl = require('./tpl/glow-modal.html')

  require('angular')
    .module(MODULE_NAME, [
      require('../../../modal'),
      require('../../../common/filter/trustHtml'),
      require('../../../common/formly'),
      require('../../../common/formly/inputs/country-select'),
      require('../../../common/formly/inputs/datepicker'),
      require('../../../common/formly/inputs/file-upload'),
      require('../../../common/formly/inputs/html-checkbox'),
      require('../../../common/formly/inputs/html-read-only'),
      require('../../../common/formly/inputs/recaptcha'),
      require('../../../common/formly/inputs/state-select'),
      require('../../../common/formly/wrappers/required'),
      require('../../../common/formly/wrappers/settings-panel')
    ])
    .component('thismomentGlowModal', {
      bindings: {
        resolve: '<',
        close: '&'
      },
      templateUrl: templateUrl,
      controller: glowModalController
    })

  glowModalController.$inject = []
  function glowModalController () {
    var vm = this
    vm.$onInit = glowModalInit

    function glowModalInit () {
      vm.busy = false
      vm.error = false
      vm.success = false

      // modal settings
      vm.parentScope = vm.resolve.options.getParentScope()

      // formly
      vm.formData = vm.parentScope.formData || {}
      vm.fields = vm.parentScope.fields
      vm.onCancel = onCancel
      vm.onClose = onClose
      vm.onCopy = onCopy
      vm.onSubmit = onSubmit

      // settings
      vm.ariaLabel = vm.parentScope.ariaLabel
      vm.cancelBackgroundColor = vm.parentScope.cancelBackgroundColor
      vm.cancelColor = vm.parentScope.cancelColor
      vm.cancelText = vm.parentScope.cancelText
      vm.errorButtonText = vm.parentScope.errorButtonText
      vm.errorColor = vm.parentScope.errorColor
      vm.errorDescription = vm.parentScope.errorDescription
      vm.errorTitle = vm.parentScope.errorTitle
      vm.processingDescription = vm.parentScope.processingDescription || 'Your submission is in progress...'
      vm.processingTitle = vm.parentScope.processingTitle || 'Submitting'
      vm.submissionBackgroundColor = vm.parentScope.submissionBackgroundColor
      vm.submissionBackgroundImage = vm.parentScope.submissionBackgroundImage
      vm.submissionFormDescription = vm.parentScope.submissionFormDescription
      vm.submissionFormDescriptionColor = vm.parentScope.submissionFormDescriptionColor
      vm.submissionFormTitle = vm.parentScope.submissionFormTitle
      vm.submissionFormTitleColor = vm.parentScope.submissionFormTitleColor
      vm.submitBackgroundColor = vm.parentScope.submitBackgroundColor
      vm.submitColor = vm.parentScope.submitColor
      vm.submitText = vm.parentScope.submitText
      vm.successButtonText = vm.parentScope.successButtonText
      vm.successColor = vm.parentScope.successColor
      vm.successDescription = vm.parentScope.successDescription
      vm.successTitle = vm.parentScope.successTitle

      // styles
      vm.styles = {}
      if (vm.submissionFormDescription) {
        vm.styles.submissionFormDescription = {color: vm.submissionFormDescriptionColor}
      }
      if (vm.submissionFormTitle) {
        vm.styles.submissionFormTitle = {color: vm.submissionFormTitleColor}
      }
      if (vm.submissionBackgroundColor) {
        vm.styles.wrapper = {'background-color': vm.submissionBackgroundColor}
      }
      if (vm.submissionBackgroundImage) { vm.styles.wrapper['background-image'] = selectImage(vm.submissionBackgroundImage, 0)['background-image'] }
      if (vm.successColor) {
        vm.styles.success = {
          button: {
            'background-color': vm.successColor,
            'border-color': vm.successColor
          },
          glyph: {
            color: vm.successColor
          }
        }
      }
      if (vm.errorColor) {
        vm.styles.error = {
          button: {
            'background-color': vm.errorColor,
            'border-color': vm.errorColor
          },
          glyph: {
            color: vm.errorColor
          }
        }
      }

      // analytics
      vm.trackEvent = vm.resolve.options.trackEvent
      vm.parentEvent = vm.resolve.options.parentEvent
      vm.parentType = vm.resolve.options.parentType
    }

    function onClose (msg) {
      vm.trackEvent(vm.parentType + ' Converted', {
        'event trigger': msg + ' ' + vm.parentEvent
      })
      vm.close()
    }

    function onCancel () {
      vm.trackEvent(vm.parentType + ' Cancelled', {
        'event trigger': 'cancelled ' + vm.parentEvent
      })
      vm.close()
    }

    function onCopy () {
      const copyText = document.getElementById('glow-modal-copy-text')
      navigator.clipboard.writeText(copyText.innerHTML)
    }

    function onSubmit () {
      var analyticsProps = {
        'event trigger': 'submitted ' + vm.parentEvent
      }
      for (var key in vm.formData) {
        if (key !== 'media') {
          analyticsProps['form data ' + key] = vm.formData[key]
        }
      }
      vm.trackEvent(vm.parentType + ' Converted', analyticsProps)
      vm.busy = true
      vm.resolve.options
        .onSubmit(vm.formData)
        .then(function (response) {
          if (vm.parentType === 'Module' && 'status' in response && response.status !== 200) {
            throw new Error()
          }
          vm.busy = false
          vm.success = true
        }).catch(function (error) {
          vm.busy = false
          vm.error = true
          console.warn(error)
        })
    }

    // TODO: Make image object creation happen on backend
    // TODO: Make selectImage actually select an appropriately-sized image
    function selectImage (data, height) {
      if (data === null) {
        return data
      }
      var obj = JSON.parse(data)
      var img = obj.metadata.images.original
      var max = height - 10
      var imgHeight = img.height
      var styles = {
        'background-image': 'url(' + obj.orig_file + ')',
        height: max + 'px'
      }

      if (imgHeight > max) {
        var ratio = max / imgHeight
        styles.width = Math.ceil(img.width * ratio) + 'px'
      } else {
        styles.width = img.width + 'px'
      }

      return styles
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/glow/component/glow-modal/glow-modal.js